<template>
  <b-form autocomplete="chrome-off">
    <b-row>
      <b-col
        md="6"
        xl="6"
      >
        <b-form-group
          label="Nombre"
          label-for="contact-search-form-name"
        >
          <b-form-input
            id="contact-search-form-name"
            v-model="form.name"
            name="contact-search-form-name"
            placeholder="(e.g. angela)"
            autocomplete="chrome-off"
            @input="onInput"
          />
        </b-form-group>
      </b-col>

      <b-col
        md="6"
        xl="6"
        class="mb-1"
      >
        <b-form-group
          label="Email"
          label-for="contact-search-form-email"
        >
          <b-form-input
            id="contact-search-form-email"
            v-model="form.email"
            name="contact-search-form-email"
            placeholder="(e.g. vanesa@nollamap.org)"
            autocomplete="chrome-off"
            @input="onInput"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BForm, BFormInput, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        email: '',
        name: '',
      }),
    },
  },
  data() {
    return {
      form: {
        email: '',
        name: '',
      },
    }
  },
  methods: {
    onSearch() {
      this.$emit('search', this.form)
    },
    onInput() {
      this.$emit('input', this.form)
    },
  },
}
</script>
